import '@/shared/design-system/index.scss'
import type { PropsWithChildren } from 'react'

export function DesignSystemProvider({
	children,
}: Readonly<PropsWithChildren>) {
	return children
}
